"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
exports.useStyles = makeStyles_1.default(() => ({
    root: {
        height: 22,
        verticalAlign: 'top',
        '&:before': {
            border: 0,
        },
    },
    input: {
        padding: '2pt',
    },
    addorment: {
        '& button': {
            padding: '3px',
        },
        '& svg': {
            height: 20,
            width: 20,
        },
    },
    dissabledAddorment: {
        display: 'none',
    },
}));
//# sourceMappingURL=time-field-styles.js.map